import { useMemo } from 'react'
import useCommerceCart, { UseCart } from '@commerce/actual-cart/use-cart'

import { SWRHook } from '@commerce/utils/types'
import { cartCreate, cartToCart } from '../utils'
import getCartQuery from '../utils/queries/get-cart-query'

import { handler as useCustomerHandler } from '../customer/use-customer';

// import {
//   GetCartQuery,
//   GetCartQueryVariables,
//   CartDetailsFragment,
// } from '../schema'

export default useCommerceCart as UseCart<typeof handler>

export const handler: SWRHook<any /* GetCartHook */> = {
  fetchOptions: {
    query: getCartQuery,
  },
  async fetcher({ input: { cartId: cartId }, options, fetch }) {
    let cart

    let customer;
    if (useCustomerHandler?.fetcher != null) {
      customer = await useCustomerHandler.fetcher({
        options: useCustomerHandler.fetchOptions,
        input: undefined,
        fetch,
      });
    }

    if (cartId) {
      const data = await fetch({
        ...options,
        variables: {
          cartId: cartId,
        },
      })
      cart = data.node
      if (cart == null) {
        // cart no longer exists
        cart = await cartCreate(fetch, false, customer)
      }
    }else{
      cart = await cartCreate(fetch, false, customer)
    }

    if (cart?.completedAt) {
      cart = await cartCreate(fetch, false, customer)
    }


    return cartToCart({ cart })
  },
  useHook: ({ useData }) => (input) => {
    const response = useData({
      swrOptions: {
        dedupingInterval: 20000,
        ...input?.swrOptions
      },
    })
    return useMemo(
      () =>
        Object.create(response, {
          isEmpty: {
            get() {
              return (response.data?.lines?.length ?? 0) <= 0
            },
            enumerable: true,
          },
        }),
      [response]
    )
  },
}
